import { render, staticRenderFns } from "./CoberturasUsuario.vue?vue&type=template&id=12c8c227&"
import script from "./CoberturasUsuario.vue?vue&type=script&lang=js&"
export * from "./CoberturasUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports